import React from "react";
import { Sparkles, Clock, MapPin, Award } from "lucide-react";

const STATS = [
  { icon: Sparkles, label: "Vehicles detailed", value: "200+" },
  { icon: Clock, label: "Years detailing", value: "2" },
  { icon: MapPin, label: "Cities served", value: "12" },
  { icon: Award, label: "Avg. rating", value: "5.0" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">          <div className="lg:col-span-6">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-4">
              About Us
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              A Southern Oregon shop<br />with old school standards.
            </h2>
            <div className="mt-8 space-y-5 text-slate-600 leading-relaxed">
              <p>
                Southern Oregon Detailing is a locally owned mobile detailing
                business serving Medford and the Rogue Valley. We started with
                one bucket, one wash mitt, and a belief that every car
                deserves the same care a collector gives their pride and joy.
              </p>
              <p>
                Today we handle daily drivers, lifted trucks, weekend
                showpieces, and everything in between, using professional
                products, dual action polishers, and certified ceramic
                coatings. No corner cutting. No upsells. Just clean cars and
                honest work.
              </p>
            </div>

            <div className="mt-10 inline-flex items-center gap-4 border-l-4 border-blue-600 pl-5">
              <div>
                <div className="font-display font-black text-xl">
                  "Treat every car like it's your own."
                </div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">
                  Our only rule
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-px bg-slate-200 border border-slate-200">
              {STATS.map((s) => {
                const Icon = s.icon;
                return (
                  <div
                    key={s.label}
                    data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="bg-white p-8 md:p-10"
                  >
                    <Icon size={22} className="text-blue-600 mb-6" />
                    <div className="font-display font-black text-5xl md:text-6xl tracking-tighter text-slate-900">
                      {s.value}
                    </div>
                    <div className="mt-2 text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
                      {s.label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
